<template>
    <b-col lg="4">
        <div class="form-item form-item-text" :class="{ 'field-error': errors.has('email') && showErrors }">
            <label for="user_data_email"
                   class="form-label">
                Email address
            </label>
            <input  id="user_data_email"
                    name="email"
                    type="text"
                    v-model="fieldValue"
                    :disabled="true">
            <p class="field-error--description" v-show="errors.has('email') && showErrors">{{ errors.first('email') }}</p>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        data () {
            return {
                fieldValue: ''
            }
        },
        computed: {
            defaultValue () {
                return this.$store.getters.user.email
            }
        },
        watch: {
            defaultValue () {
                this.fieldValue = this.defaultValue
            },
        },
        mounted () {
            this.fieldValue = this.defaultValue
        }
    }
</script>

<style lang="scss" scoped>
    :disabled{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile-edit-data/Email.vue